import Api from '../../lib/Api'
import Consts from '../../lib/Consts'
import i18n from '../../lib/i18n'
import router from '../../router'
import UUID from '../../lib/UUID'

export default {
  namespaced: true,
  state: {
    requestUUID: null,
    requestAmount: 0,
    isSending: false,
    isSent: false,
    isSendError: false
  },
  getters: {
    requirementGTE (state, getters, rootState) {
      return rootState.serverConstants.leastJewelToExchange
    },
    requirementLTE (state, getters, rootState) {
      return rootState.currentUserInfo.jewelBalance
    },
    requirementMultipleOf (state, getters, rootState) {
      return rootState.serverConstants.exchangeStep
    },
    isSufficientLTE (state, getters) {
      if (getters.requirementLTE === null) { return false }

      return state.requestAmount <= getters.requirementLTE
    },
    isSufficientGTE (state, getters) {
      return state.requestAmount >= getters.requirementGTE
    },
    isSufficientMultiple (state, getters) {
      return state.requestAmount % getters.requirementMultipleOf === 0
    },
    isSufficient (state, getters) {
      return getters.isSufficientLTE && getters.isSufficientGTE && getters.isSufficientMultiple
    }
  },
  mutations: {
    clearRequestUUID (state) {
      state.requestUUID = null
    },
    setRequestUUID (state, { requestUUID }) {
      state.requestUUID = requestUUID
    },
    setRequestAmount (state, { amount }) {
      state.requestAmount = amount
    },
    sendStatusInitial (state) {
      state.isSending = false
      state.isSent = false
      state.isSendError = false
    },
    sendStateBegin (state) {
      state.isSending = true
      state.isSent = false
      state.isSendError = false
    },
    sendStateDone (state) {
      state.isSending = false
      state.isSent = true
      state.isSendError = false
    },
    sendStateError (state) {
      state.isSending = false
      state.isSent = false
      state.isSendError = true
    }
  },
  actions: {
    generateUUID ({ commit }) {
      commit('setRequestUUID', { requestUUID: UUID.uuid4() })
    },
    init ({ commit, dispatch, getters }) {
      dispatch('generateUUID')
      commit('setRequestAmount', { amount: getters.requirementGTE })
    },
    async submit ({ commit, dispatch, state }) {
      commit('sendStateBegin')
      try {
        await Api.postExchangeRequest({ requestUUID: state.requestUUID, amount: state.requestAmount })
        commit('sendStateDone')
      } catch (e) {
        let errorMessage = 'Unknown error'
        if (e.response.data.error) {
          errorMessage = i18n.t('apiError', {
            message: e.response.data.error.message,
            code: e.response.data.error.error_code
          })
        }
        dispatch('displayAlert', { message: errorMessage }, { root: true })

        if (e.response.status === 401 && e.response.data.error.error_code === Consts.serverErrorCodes.CANNOT_AUTHENTICATE_USER) {
          dispatch('session/logout', null, { root: true })
          router.replace('/auth')
          commit('sendStatusInitial')
          return
        }
        if (e.response.status === 403 && e.response.data.error.error_code === Consts.serverErrorCodes.AGENCY_USER_CANNOT_REQUEST) {
          router.replace('/')
          commit('sendStatusInitial')
          await dispatch('currentUserInfo/fetch', null, { root: true })
          return
        }
        if (e.response.status === 400) {
          await dispatch('currentUserInfo/fetch', null, { root: true })
          await dispatch('serverConstants/fetch', null, { root: true })
          router.push('/request_exchange')
          commit('sendStatusInitial')
          return
        }

        commit('sendStateError')
        throw e
      }
    }
  }
}
